import { format } from 'date-fns';
import React from 'react';
import { AutomationRunActionFragment } from 'shared/types/graphql';
import { Flex } from '@televet/kibble-ui/build/chakra';

interface IAutomationRunSystemMessageProps {
  automationRunAction: AutomationRunActionFragment | undefined;
}

const AutomationRunSystemMessage = ({ automationRunAction }: IAutomationRunSystemMessageProps): JSX.Element => {
  // DON'T truncate 'selected by' pet parent responses to surveys
  // DO truncate 'submitted by' responses to surveys

  let response = automationRunAction?.body || '';
  const submittedByIndex = response?.toLowerCase().lastIndexOf('submitted by');

  if (submittedByIndex > -1) {
    const originalResponse = response.slice(0, submittedByIndex);
    if (originalResponse.length > 100) {
      response = response
        .slice(0, submittedByIndex - 1)
        .substring(0, 100)
        .trim()
        .concat(`..." ${response.slice(submittedByIndex)}`);
    }
  }

  return (
    <Flex fontSize="sm" py={2} mt={1} px={3}>
      {`${response} on ${format(new Date(automationRunAction?.createdAt), "MM-dd-yyyy 'at' h:mmaaa ")}`}
    </Flex>
  );
};

export default AutomationRunSystemMessage;
